import { Builder } from '@builder.io/react';
import TeamCards from './TeamCards';

Builder.registerComponent(TeamCards, {
  name: 'TeamCards',
  inputs: [
    {
      name: 'team',
      type: 'list',
      defaultValue: [{
        photo: '',
        name: 'Name here',
      }],
      copyOnAdd: true,
      subFields: [
        {
          name: 'photo',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'gif', 'svg'],
        },
        {
          name: 'name',
          type: 'string',
        },
        {
          name: 'title',
          type: 'longText',
        },
        {
          name: 'social',
          type: 'object',
          defaultValue: {
            network: 'linkedin',
            url: '/',
          },
          subFields: [
            {
              name: 'network',
              type: 'string',
              enum: [
                'linkedin',
                'twitter',
                'instagram',
                'mastodon',
              ],
            },
            {
              name: 'url',
              type: 'string',
            },
          ],
          helperText: 'Only one link to a social is currently supported.'
        }
      ],
    },
  ],
});
